import { render, staticRenderFns } from "./CreatedAt.vue?vue&type=template&id=0df083de&scoped=true"
import script from "./CreatedAt.vue?vue&type=script&lang=js"
export * from "./CreatedAt.vue?vue&type=script&lang=js"
import style0 from "./CreatedAt.vue?vue&type=style&index=0&id=0df083de&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0df083de",
  null
  
)

export default component.exports